import {
  TextField,
  FormGroup,
  InputLabel,
  MenuItem,
  Switch,
  IconButton,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import GoogleMaps from "./GoogleGeocode";
import { ReactComponent as MySvg } from "../images/Google_Gemini_icon_2025.svg";
import { ReactComponent as MySvgDisabled } from "../images/Google_Gemini_icon_2025_disabled.svg";
import { getEditorTrackingFieldNames } from "../helpers/schemas/getEditorTrackingFields";

dayjs.extend(utc);

export default function LayerFormFields({
  feature,
  schema,
  onChange,
  onAddressChange,
  onMapChange,
  onAi,
}) {
  return (
    <div>
      {schema.map((att, idx) =>
        att.name !== "id" &&
        att.name !== "deleted" &&
        getEditorTrackingFieldNames().includes(att.name) === false &&       
        att.name !== "project_id" &&
        att.name !== "client_id" &&
        att.name !== "contractor_id" &&
        att.name !== "issue_id" &&
        att.name !== "fileCount" &&
        att.name !== "issueCount" &&
        att.name !== "checklistCount" &&        
        att.name !== "commentCount" &&
        att.name !== "No" &&
        att.readOnly !== true &&
        att.name !== "observation_id" ? (
          <div key={idx}>
            <FormGroup
              style={{ paddingTop: "10", paddingBottom: "12px" }}
              size="small"
            >
              {att.name !== "Address" && (
                <InputLabel htmlFor={att.name}>
                  {att.name
                    .replace("_id", "")
                    .replace(/_/g, " ")
                    .replace(/\w\S*/g, (w) =>
                      w.replace(/^\w/, (c) => c.toUpperCase()),
                    )}
                </InputLabel>
              )}
              {att.type === "bit" ? (
                <Switch
                  checked={feature[att.name]}
                  onChange={onChange}
                  id={att.name}
                  name={att.name}
                  inputProps={{ "aria-label": "controlled" }}
                />
              ) : att.type === "datetime" ? (
                <DayPicker
                  mode="single"
                  selected={feature[att.name]}
                  onSelect={onChange}
                  footer={
                    feature[att.name]
                      ? `Selected: ${feature[att.name].toLocaleDateString()}`
                      : "Pick a day."
                  }
                />
              ) : att.type === "address" ? (
                <GoogleMaps
                  feature={feature}
                  onAddressChange={onAddressChange}
                  onChange={onChange}
                  onMapChange={onMapChange}
                  helperText={att.helperText}
                  error={att.error}
                  name={att.name}
                />
              ) : (
                <TextField
                  size="small"
                  variant="outlined"
                  key={idx + 4}
                  // label={'test'}
                  placeholder={att.helperText}
                  helperText={
                    (feature[att.name] === null && att.helperText) ||
                    (feature[att.name] === undefined && att.error) ||
                    (feature[att.name] === "" && att.error)
                      ? att.helperText
                      : ""
                  }
                  error={
                    (feature[att.name] === null && att.error) ||
                    (feature[att.name] === undefined && att.error) ||
                    (feature[att.name] === "" && att.error)
                  }
                  select={att.selectables.length > 0}
                  type={
                    att.selectables.length > 0
                      ? "select"
                      : att.type === "string"
                        ? "text"
                        : att.type === "date"
                          ? "date"
                          : att.type === "int" ||
                              att.type === "money" ||
                              att.type === "number"
                            ? "number"
                            : att.type === "string" &&
                                att.maxLength > 100 &&
                                att.selectables.length === 0
                              ? "textarea"
                              : att.type === "varbinary"
                                ? "file"
                                : "text"
                  }
                  accept="image/x-png,image/jpeg"
                  disabled={att.readOnly}
                  multiline={att.maxLength !== null && att.maxLength > 254}
                  rows={att.maxLength !== null && att.maxLength > 254 ? 4 : 1}
                  inputProps={{
                    maxLength:
                      att.maxLength !== null && att.maxLength > -1
                        ? att.maxLength
                        : 60,
                  }}
                  id={att.name}
                  invalid={
                    att.nullable === false && feature[att.name] === ""
                      ? "true"
                      : "false"
                  }
                  name={att.name}
                  value={feature[att.name]}
                  onChange={onChange}
                >
               
                  {att.selectables.map((code, idx) => (
                    <MenuItem key={idx} value={code}>
                      {code}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            
            </FormGroup>
            {att.maxLength !== null && att.maxLength > 254 && (
              <Tooltip title="Enhance text using Google Gemini AI">
                <IconButton
                  color="primary"
                  disabled={
                    feature[att.name] && feature[att.name].length > 25
                      ? false
                      : true
                  }
                  onClick={() =>
                    onAi(feature[att.name], att.name, att.maxLength)
                  }
                >
                  {feature[att.name] && feature[att.name].length > 25 ? (
                    <SvgIcon component={MySvg} inheritViewBox />
                  ) : (
                    <SvgIcon component={MySvgDisabled} inheritViewBox />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </div>
        ) : null,
      )}
    </div>
  );
}
